// Shared helper functions for AgentResponse components

// Types
export type Section = {
  title: string;
  text?: string | JSX.Element;
  list?: string[];
  img: string;
};

// Calculate required qualifications met for scoring agent
export const calculateRequiredQualificationsMet = (candidate: any) => {
  let met = 0;
  let total = 0;
  const requiredQualifications =
    candidate?.skills_match?.required_qualification || {};

  ["education", "location", "experience"].forEach((field) => {
    const qualifiedKey = `is_${field}_qualified`;
    if (requiredQualifications[field]) {
      total++;
      if (requiredQualifications[qualifiedKey]?.toLowerCase() === "yes")
        met++;
    }
  });

  return { met, total };
};

// Calculate resume mining answers met for scoring agent
export const calculateResumeMiningAnswersMet = (candidate: any) => {
  let met = 0;
  const miningAnswers = candidate?.resume_mining_answers || [];
  const total = miningAnswers.length;

  miningAnswers.forEach((answer: any) => {
    if (answer.answer?.toLowerCase() === "yes") met++;
  });

  return { met, total };
};
